import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconFishHook = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M16 2a1 1 0 0 1 1 1v1.17a3.001 3.001 0 0 1 0 5.66V15a6 6 0 1 1-12 0v-4a1 1 0 0 1 1.707-.707l3 3a1 1 0 0 1-1.414 1.414L7 13.414V15a4 4 0 1 0 8 0V9.83a3.001 3.001 0 0 1 0-5.66V3a1 1 0 0 1 1-1m0 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
            clipRule="evenodd"
        />
    </svg>
);
